import { useAuth } from '../../../contexts/AuthContext'
import { parseJwt } from '../../../services/token'

// Gestor com permissão só de cargos ou salários enxerga apenas a própria equipe e não edita nada
export function useVisaoGestor (): boolean {
  const { permitirFuncao } = useAuth()

  return parseJwt().adm !== 'True' && !permitirFuncao('CargosESalarios', 'Acesso')
}
